'use strict';
module.exports = [
  require('./reviver')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/json/index.js
// module id = 1878
// module chunks = 0